module.exports = __webpack_public_path__ + "img/oeillet2_md.37b7141e.jpg";